#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

mutation SharedEmailAddressRemove($input: SharedEmailAddressRemoveInput!) {
    sharedEmailAddressRemove(input: $input) {
        fromAddress {
            ...FromAddress
        }
    }
}
